import React from "react";
import SEO from "../Components/SEO";
//IMG IMPORT
import jodustlogo from "../images/onama/Jodust.png";


function About() {
    return (
        <>
            <SEO
                title="O nama | Proizvodnja ALU i PVC stolarije JODUST"
                description="JODUST iz Lebana - dugogodišnja tradicija u proizvodnji i montaži ALU i PVC stolarije. Kvalitetni materijali, precizna izrada, profesionalna montaža. Poslujemo širom Srbije i regiona."
                keywords="o nama JODUST, proizvodnja stolarije Lebane, ALU stolarija Leskovac, PVC stolarija Srbija, montaža stolarije, JODUST firma"
                image={jodustlogo}
                author="JODUST"
            />


            <main>

                {/* HERO */}
                <section
                    className="text-white text-center py-5"
                    style={{ backgroundColor: "#1f4068" }}
                >
                    <div className="container py-5">

                        <h1 className="display-5 fw-bold">
                            O firmi JODUST
                        </h1>

                        <p className="lead mt-3">
                            Profesionalna proizvodnja i montaža ALU i PVC stolarije
                            za domove i poslovne objekte.
                        </p>

                    </div>
                </section>


                {/* ABOUT TEXT */}
                <section className="py-5">
                    <div className="container">

                        <div className="row align-items-center">

                            <div className="col-lg-6">
                                <img
                                    src={jodustlogo}
                                    className="img-fluid"
                                    alt="Proizvodnja ALU i PVC stolarije"
                                />
                            </div>

                            <div className="col-lg-6">

                                <h2 className="fw-bold mb-3">
                                    Dugogodišnje iskustvo u ALU i PVC stolariji
                                </h2>

                                <p>
                                    Firma JODUST iz Lebana bavi se proizvodnjom i montažom
                                    aluminijumske i PVC stolarije već duži niz godina. Tokom
                                    našeg rada stekli smo veliko iskustvo u izradi kvalitetnih
                                    prozora, vrata i drugih sistema stolarije koji odgovaraju
                                    potrebama savremenih objekata.
                                </p>

                                <p>
                                    Naš tim čine stručni i posvećeni majstori koji posebnu
                                    pažnju posvećuju svakom projektu – od prvog kontakta sa
                                    klijentom, preko preciznog merenja i izrade, pa sve do
                                    profesionalne montaže. Verujemo da kvalitet počinje
                                    dobrim planiranjem i zato svakom poslu pristupamo
                                    odgovorno i temeljno.
                                </p>

                                <p>
                                    U proizvodnji koristimo proverene profile i kvalitetne
                                    materijale koji obezbeđuju dug vek trajanja proizvoda,
                                    visoku energetsku efikasnost i odličnu zvučnu izolaciju.
                                    Naša stolarija doprinosi boljoj zaštiti prostora od
                                    spoljašnjih uticaja, smanjuje gubitke energije i
                                    poboljšava ukupnu udobnost u domu ili poslovnom objektu.
                                </p>

                                <p>
                                    Zahvaljujući dugogodišnjem iskustvu i brojnim uspešno
                                    realizovanim projektima, JODUST je stekao poverenje
                                    velikog broja zadovoljnih klijenata koji nam se
                                    ponovo obraćaju i preporučuju nas drugima.
                                </p>

                            </div>

                        </div>

                    </div>
                </section>

                <section className="py-5 bg-light">
                    <div className="container text-center">

                        {/* Tekst iznad slike */}
                        <h2 className="fw-bold mb-3">
                            Poslujemo širom Srbije i regiona
                        </h2>
                        <p className="lead mb-4">
                            Firma JODUST uspešno posluje sa klijentima širom Srbije,
                            pružajući kompletnu uslugu proizvodnje, prodaje i
                            profesionalne montaže ALU i PVC stolarije. Naši proizvodi
                            ugrađeni su u brojnim porodičnim kućama, stanovima,
                            poslovnim prostorima i industrijskim objektima.
                        </p>

                        <p className="lead mb-4">
                            Pored domaćeg tržišta, sarađujemo i sa partnerima u
                            regionu, gde realizujemo različite projekte u oblasti
                            modernih sistema stolarije. Bez obzira na veličinu
                            projekta, trudimo se da svakom klijentu pružimo
                            maksimalan kvalitet usluge i pouzdanu podršku tokom
                            čitavog procesa saradnje.
                        </p>
                    </div>
                </section>

                {/* SERVICES */}
                <section className="bg-light py-5">
                    <div className="container">

                        <h2 className="text-center fw-bold mb-5">
                            Šta radimo
                        </h2>

                        <div className="row g-4">

                            <div className="col-md-4">
                                <div className="card shadow border-0 h-100">
                                    <div className="card-body">
                                        <h3 className="h5">PVC prozori i vrata</h3>
                                        <p>
                                            U proizvodnji koristimo kvalitetne profile, moderne
                                            mašine i proverene materijale kako bismo obezbedili
                                            dugotrajnost, sigurnost i vrhunsku završnu obradu
                                            svakog proizvoda.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="card shadow border-0 h-100">
                                    <div className="card-body">
                                        <h3 className="h5">ALU stolarija</h3>
                                        <p>
                                            Naš tim prati savremene standarde u proizvodnji i
                                            montaži stolarije. Svaki projekat realizujemo
                                            odgovorno, uz poštovanje rokova i dogovora sa
                                            klijentima.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="card shadow border-0 h-100">
                                    <div className="card-body">
                                        <h3 className="h5">Dodatni program</h3>
                                        <p>
                                            Zadovoljstvo naših klijenata nam je na prvom mestu.
                                            Zato se trudimo da pružimo kvalitetnu uslugu,
                                            stručne savete i dugoročna rešenja koja će
                                            ispuniti očekivanja svakog investitora.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>

                <section className="bg-light py-5">
                    <div className="container text-center">

                        <h2 className="fw-bold mb-4">
                            Zašto izabrati JODUST?
                        </h2>

                        <div className="row g-4">

                            <div className="col-md-3">
                                <h3 className="h6 fw-bold">Kvalitetni materijali</h3>
                                <p>Koristimo proverene PVC i ALU profile visokog kvaliteta.</p>
                            </div>

                            <div className="col-md-3">
                                <h3 className="h6 fw-bold">Precizna izrada</h3>
                                <p>Savremena oprema omogućava preciznu i dugotrajnu izradu.</p>
                            </div>

                            <div className="col-md-3">
                                <h3 className="h6 fw-bold">Profesionalna montaža</h3>
                                <p>Naš tim vrši stručnu i sigurnu ugradnju stolarije.</p>
                            </div>

                            <div className="col-md-3">
                                <h3 className="h6 fw-bold">Pouzdana saradnja</h3>
                                <p>Gradimo dugoročne odnose sa našim klijentima.</p>
                            </div>

                        </div>

                    </div>
                </section>

                {/* VALUES */}
                <section className="py-5">
                    <div className="container">

                        <h2 className="text-center fw-bold mb-5">
                            Naš pristup radu
                        </h2>

                        <div className="row text-center g-4">

                            <div className="col-md-4">
                                <h3 className="h5 fw-bold">Kvalitet</h3>
                                <p>
                                    Koristimo proverene materijale i savremenu opremu kako
                                    bismo obezbedili dugotrajnost i pouzdanost proizvoda.
                                </p>
                            </div>

                            <div className="col-md-4">
                                <h3 className="h5 fw-bold">Profesionalnost</h3>
                                <p>
                                    Svakom projektu pristupamo profesionalno i pedantno,
                                    uz poštovanje rokova i dogovora sa klijentima.
                                </p>
                            </div>

                            <div className="col-md-4">
                                <h3 className="h5 fw-bold">Zadovoljstvo klijenata</h3>
                                <p>
                                    Naš cilj je da svaki klijent dobije rešenje koje
                                    odgovara njegovim željama i potrebama.
                                </p>
                            </div>

                        </div>

                    </div>
                </section>


                {/* CTA */}
                <section
                    className="text-white text-center py-5"
                    style={{ backgroundColor: "#1f4068" }}
                >

                    <div className="container">

                        <h2 className="fw-bold">
                            Potrebna vam je nova stolarija?
                        </h2>

                        <p className="lead mt-3">
                            Kontaktirajte nas za besplatnu procenu i ponudu.
                        </p>

                        <a href="/contact" className="btn btn-warning btn-lg mt-3">
                            Kontaktirajte nas
                        </a>

                    </div>

                </section>

            </main>
        </>
    );
}

export default About;